<template>
  <div class="p-0 mt-3">
 
    <VueTailwindDatepicker 
    :autoApply="true"
     :shortcuts="false" 
     :useRange="useRange" :i18n="lang" :formatter="formatter"
      :startFrom="startFrom"  
      v-model="dateValue" 
      @update:modelValue="handleApply" />


  </div>
</template>


<script>
import { ref } from 'vue'
import VueTailwindDatepicker from 'vue-tailwind-datepicker'
import i18n from '@/i18n';
export default {
  components: {
    VueTailwindDatepicker
  },
  props: ['fechasSeleccionadas','propUseRange'],
  emits: ['getFecCalendar'],
  mounted() {
    this.lang =  i18n.global.locale.value;
  },
  data() {
    return {
      showRegularDate: true,
      checkin: '',
      useRange: this.propUseRange==false ? false : true,
      startFrom: '',
      dateValue:  ref(''),
      formatter: ref({
        date: 'DD MM YYYY',
        month: 'MMM',

      }),
      lang:''

    }
  },
  watch: {
   fechasSeleccionadas(value) {
      this.dateValue = []
      this.startFrom = value[0]
      this.dateValue = value

    },  
    dateValue() {

   //   this.getFecCalendar();
    },
  },
  methods: {
    closeDatePickerPopup() {
   
    
      
    },
    
    handleApply(){
     
      //console.log(this.dateValue, "<--");
      this.$emit("getFecCalendar", this.dateValue)
    },
    getFecCalendar() {
      //console.log(this.dateValue, "<--");
      this.$emit("getFecCalendar", this.dateValue)
    }
  },
}
</script>